import Vue from 'vue'
import store from '@/store'
import axios from 'axios'
import VueCookie from 'vue-cookie'
import { pick } from 'lodash'

Vue.use(VueCookie)

const Axios = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL
})

console.log(process.env.VUE_APP_API_BASE_URL)

Axios.interceptors.response.use(resp => {
  store.commit('SET_API_ERROR', false)

  if (resp.headers['access-token']) {
    const authHeaders = pick(resp.headers, ['access-token', 'client', 'expiry', 'uid', 'session-type'])
    const type = authHeaders['session-type']
    store.commit(`SET_${type.toUpperCase()}_AUTH`, authHeaders)

    let session = VueCookie.get(`${type}_session`)
    if (session) {
      let currentSession = JSON.parse(session)
      let expireDate = currentSession['remember'] ? 14 : 1

      currentSession['tokens'] = authHeaders
      VueCookie.set(`${type}_session`, JSON.stringify(currentSession), { expires: expireDate })
    }
  }
  return resp
}, error => {
  // Handle errors with notifications
  if (!error.response) {
    store.commit('SET_API_ERROR', true)
  } else {
    store.commit('SET_API_ERROR', false)
  }
  store.commit('SET_LOADING_REQUEST', false)
  return Promise.reject(error)
})

export default Axios
